import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
    theme: {
        themes: {
            light: {
                primary: "#00adff",
                background: "#35495e",
                error: "#d63031",
                info: "#0984e3",
                secondary: "#fdcb6e",
                success: "#00cec9",
                surface: "#6c5ce7",
                warning: "#2d3436",

                black: "#0f1928",
                gray: "#939393",
                headerBackground: "#00adff",
                timeLine: "#dd08cb",
            },
            dark: false,
            variables: {},
        },
    },
};

export default new Vuetify(opts);
